import { useEffect, useState } from 'react'
import { apiGet } from '../utils/api'
import { useI18n } from '../i18n'

type Tenant = { id: number; name: string; active: boolean }

export default function Tenants() {
  const { t } = useI18n()
  const [tenants, setTenants] = useState<Tenant[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string|undefined>()

  useEffect(() => {
    (async () => {
      try {
        const data = await apiGet('/tenants')
        setTenants(data)
      } catch (e: any) {
        setError(e?.message || 'Failed to load tenants')
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  if (loading) return <p>{t('common.loading')}</p>
  if (error) return <p style={{ color: 'crimson' }}>{error}</p>

  return (
    <div>
      <h2>{t('titles.tenants')}</h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">{t('help.tenants')}</p>
      <ul>
        {tenants.map(t => (
          <li key={t.id}>{t.name} {t.active ? '' : '(inactive)'}</li>
        ))}
      </ul>
    </div>
  )
}

